/**
 * Base LitElement : injecte visualCustomization (variables CSS + customCSS) dans le shadow root.
 * Id du nœud : {@link APIDAE_CUSTOM_STYLES_ELEMENT_ID} (voir StyleService).
 */

import { LitElement, PropertyValues } from "lit";
import { property } from "lit/decorators.js";
import type { WidgetVisualCustomization } from "../types/widgets.d";
import { StyleService } from "../services/StyleService";

export class ApidaeVisualHost extends LitElement {
  @property({ type: Object, attribute: false })
  visualCustomization: WidgetVisualCustomization | null = null;

  connectedCallback() {
    super.connectedCallback();
    this.applyApidaeCustomStyles();
  }

  updated(changedProperties: PropertyValues) {
    super.updated(changedProperties);
    if (changedProperties.has("visualCustomization")) {
      this.applyApidaeCustomStyles();
    }
  }

  /** Réinjecte les styles personnalisés (surcharge possible si la source n’est pas `visualCustomization`). */
  protected applyApidaeCustomStyles(): void {
    StyleService.applyVisualCustomizationToShadowRoot(
      this.shadowRoot,
      this.visualCustomization ?? undefined,
    );
  }
}
